import {FFmpeg} from '@ffmpeg/ffmpeg';
import { fetchFile } from "@ffmpeg/util";
import {tryCatchUtil} from "../../../utils"; // 假设使用 @ffmpeg/util 提供的 fetchFile

const inputName = "home/input.mp4";
const frameDir = 'home/video_convert_frames';
const frameHeadName = "frame_";// 每个帧文件的最前面的名字
const frameCnt = 6;// 最大帧数的数字位数，比如数字位3则最大帧数为9999
export async function convertVideoToGIF(ffmpeg: FFmpeg, inputPath: string, outputPath: string, options: {
    startTime?: string;  // 如 "00:00:10"
    endTime?: string;   // 如 "00:00:15"
    duration?: number;   // 单位：秒
    scale?: number;      // GIF 分辨率
    fps?: number;        // 帧率
    speed?: number;        // 播放速度，1.0为正常速度
}) {
    // 读取输入视频文件
    const videoData = await fetchFile(inputPath);
    await ffmpeg.writeFile(inputName, videoData);

    // Create directory for frames of input video
    tryCatchUtil(
        async () => await ffmpeg.createDir(frameDir),
        (error) => console.error("Failed to create directory:", error)
    );

    // 构建 FFmpeg 命令参数
    let vf = `fps=${options.fps || 10},scale=${options.scale || 320}:-1:flags=lanczos,setpts=${options.speed ? 1 / options.speed : 1}*PTS`;
    // const frameImgFormat = `${frameDir}/${frameHeadName}%0${frameCnt}d.png`;

    const args = [];
    // 添加截取视频片段参数
    if (options.startTime) args.push("-ss", options.startTime); // 开始时间
    if (options.endTime) {
        args.push("-to", options.endTime);
    } else if (options.duration) {
        args.push("-t", options.duration.toString());
    }
    args.push("-i", inputName);

    // // 生成调色板
    // const paletteArgs = [
    //     ...args,
    //     "-vf", vf,
    //     '-frame_pts', '1',
    //     frameImgFormat,
    // ];
    // console.log(paletteArgs);
    const gifArgs = [
        ...args,
        "-vf", vf,
        '-f', 'gif',
        "-y", // 覆盖输出文件
        outputPath
    ];

    // await ffmpeg.exec(paletteArgs);
    // console.log(await ffmpeg.listDir(frameDir));

    // 使用调色板生成 GIF
    await ffmpeg.exec(gifArgs);

    // 读取生成的 GIF 文件
    const gifData = await ffmpeg.readFile(outputPath);
    await ffmpeg.terminate(); // 释放资源
    return new Blob([gifData], { type: "image/gif" });
}


export async function extractVideoSegment(ffmpeg: FFmpeg, inputPath: string, outputPath: string, options: {
    startTime?: string;  // 如 "00:00:10"
    endTime?: string;   // 如 "00:00:15"
    duration?: number;   // 单位：秒
}) {
    // 读取输入视频文件
    const videoData = await fetchFile(inputPath);
    await ffmpeg.writeFile(inputName, videoData);

    // 构建 FFmpeg 命令参数
    const args = [];
    // 添加截取视频片段参数
    if (options.startTime) args.push("-ss", options.startTime); // 开始时间
    if (options.endTime) {
        args.push("-to", options.endTime);
    } else if (options.duration) {
        args.push("-t", options.duration.toString());
    }
    args.push("-i", inputName);

    // 生成调色板
    const paletteArgs = [
        ...args,
        "-c:v", "copy",
        "-c:a", "copy",
        "-crf", "11",// 设置视频质量，数值越低质量越高
        outputPath,
    ];

    console.log(paletteArgs)
    await ffmpeg.exec(paletteArgs);

    // 读取输出文件
    const segmentData = await ffmpeg.readFile(outputPath);
    await ffmpeg.terminate();
    return new Blob([segmentData], { type: "video/mp4" });
}
